import type { RouterConfig } from '@nuxt/schema';

// https://nuxt.com/docs/api/nuxt-config#router
// https://router.vuejs.org/api/interfaces/RouterOptions.html
export default <RouterConfig> {
  scrollBehavior(to, _from, _savedPosition) {
    // Hash will be handled natively by the browser
    // This enable supports of scroll margin scroll-mt-[80px]
    if (to.hash) return;
    return { top: 0 };
  },
};
